import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthTokenService} from '../../shared/services/auth-token.service';
import {animate} from '@angular/animations';
import {UsersService} from './users.service';
import {UserModel} from './../../models/user/users.model';
import { ClientEnum, ClientModel } from '../../models/survey/survey.model';
import { PreviousUrlService } from '../../shared/services/previous-url.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.less'],
  animations: animate['slideInOutAnimation'],
  
})
export class UsersComponent implements OnInit {

  users: UserModel[];
  visibleUsers: UserModel[];
  filter: boolean;
  column: string;
  isDesc: boolean;
  searchText = "";
  loader: boolean;
  isAdmin: boolean;
  isCustomerAdmin: boolean;
  clients: ClientModel[];
  clientFilter: any;
  clientFilterDefaultValue =  ClientEnum.INTERNAL;

  constructor(private router: Router, private route: ActivatedRoute, private shareService: PreviousUrlService, private usersService: UsersService) {
    this.route.data.subscribe(data => {
        this.clients = data.clients;
        const client = this.clients.find(item => {
            return item.name == ClientEnum.INTERNAL;
        });
        if (client !== undefined) {
            this.clientFilter = client;
        }
    });
  }

  ngOnInit() {
    this.shareService.setSurveyTitle('Users');
    this.filter = false;
    this.column = 'lastName';
    this.isDesc = false;
    this.loader = true;
    this.usersService.getAll().subscribe(
      (response) => {
        this.loader = false;
        this.users = response;
        this.visibleUsers = this.users.slice(0);
        this.filterUser(this.clientFilter, this.searchText);
      },
      (error) => {
        // console.log(error);
      }
    );
    this.isAdmin = AuthTokenService.isAdmin();
    this.isCustomerAdmin = AuthTokenService.isCustomerAdmin();
  }

  filterUsers(user) {
    this.filterUser(this.clientFilter, user);
  }

  sort(user) {
    this.isDesc = !this.isDesc;
    this.column = user;
    const direction = this.isDesc ? 1 : -1;

    this.visibleUsers.sort(function (a, b) {
      if (a[user] < b[user]) {
        return -1 * direction;
      }
      else if (a[user] > b[user]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }

  filterUserByClient(client): void {
      this.clientFilter = client;
      this.filterUser(this.clientFilter, this.searchText);
  }

  private filterUser(client: any, searchText: string) {
    if (this.isCustomerAdmin) {
        this.visibleUsers = this.users.filter(
            user => {
            return (
                (user.firstName.toLowerCase().includes(searchText.toLowerCase()) ||
                user.lastName.toLowerCase().includes(searchText.toLowerCase()) ||
                user.position.toLowerCase().includes(searchText.toLowerCase()))
            );
            }
        )
    } else {
        if (client === 'Any') {
            this.visibleUsers = this.users.filter(
                user => {
                return (
                    (user.firstName.toLowerCase().includes(searchText.toLowerCase()) ||
                    user.lastName.toLowerCase().includes(searchText.toLowerCase()) ||
                    user.position.toLowerCase().includes(searchText.toLowerCase()))
                );
                }
            )
        } else {
            this.visibleUsers = this.users.filter(
                user => {
                return (
                    user.clientId === client.id &&
                    (user.firstName.toLowerCase().includes(searchText.toLowerCase()) ||
                    user.lastName.toLowerCase().includes(searchText.toLowerCase()) ||
                    user.position.toLowerCase().includes(searchText.toLowerCase()))
                );
                }
            )
        }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/users/users.component.ts